import React, { FC } from "react";
import { InternalLink } from "../../../links/InternalLink";
import { colors } from "../../../../styles/variables";
import { StyledLink, StyledSubNav } from "./index.styled";

export interface SubNavItem {
  display: string;
  id?: string;
  url: string;
}

export interface SubNavProps {
  subNav: SubNavItem[];
}

export const SubNav: FC<SubNavProps> = ({ subNav }) => {
  return (
    <StyledSubNav data-testid="ui-header-sub-nav">
      {subNav.map((item, i) => (
        <StyledLink key={`${i}-${item.display}`}>
          <InternalLink href={item.url} color={colors.white}>
            {item.display}
          </InternalLink>
        </StyledLink>
      ))}
    </StyledSubNav>
  );
};
